var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.75C18 14.3063 14.3063 18 9.75 18C5.19365 18 1.5 14.3063 1.5 9.75C1.5 5.19365 5.19365 1.5 9.75 1.5C14.3063 1.5 18 5.19365 18 9.75ZM14.8681 18.0502C13.3805 18.9695 11.6272 19.5 9.75 19.5C4.36522 19.5 0 15.1348 0 9.75C0 4.36522 4.36522 0 9.75 0C15.1348 0 19.5 4.36522 19.5 9.75C19.5 11.6273 18.9695 13.3806 18.0501 14.8683L23.6517 20.4698C23.9445 20.7627 23.9445 21.2376 23.6517 21.5305L21.5303 23.6518C21.2374 23.9447 20.7626 23.9447 20.4697 23.6518L14.8681 18.0502ZM16.0936 17.1544L21 22.0608L22.0607 21.0001L17.1542 16.0937C16.8283 16.4738 16.4736 16.8285 16.0936 17.1544Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25C9 4.83579 9.33579 4.5 9.75 4.5C10.1642 4.5 10.5 4.83579 10.5 5.25V14.25C10.5 14.6642 10.1642 15 9.75 15C9.33579 15 9 14.6642 9 14.25V5.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75C6 9.33579 6.33579 9 6.75 9C7.16421 9 7.5 9.33579 7.5 9.75V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V9.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C12 7.83579 12.3358 7.5 12.75 7.5C13.1642 7.5 13.5 7.83579 13.5 8.25V14.25C13.5 14.6642 13.1642 15 12.75 15C12.3358 15 12 14.6642 12 14.25V8.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-chart.ab898beeb4531f8c723447cb56fff20e.svg";